module.exports = __webpack_public_path__ + "static/media/discover.757155e4.svg";